import React, { FC, useRef, useState } from 'react';
import {
  EmailIcon,
  HideIcon,
  PasswordIcon,
  PersonIcon,
} from '../../../assets/icons';

type TextFieldProps = {
  name: string;
  value?: string;
  type?: string;
  placeholder?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: Boolean;
  errorMsg?: string;
  icon?: React.ReactNode;
  disabled?: boolean;
  checked?: boolean;
};

const TextField: FC<TextFieldProps> = ({
  name,
  value,
  type,
  placeholder,
  onChange,
  error,
  errorMsg,
  icon,
  disabled,
  checked,
}) => {
  const ref = useRef<HTMLInputElement>(null);
  // const [focus, setFocus] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState<boolean>(false);

  // const handleFocus = () => {
  //   if (ref.current) {
  //     setFocus(true);
  //   }
  // };

  // const handleBlur = () => {
  //   if (ref.current) {
  //     setFocus(false);
  //   }
  // };

  return (
    <div className='flex flex-col w-full relative' ref={ref}>
      <div className='relative flex items-center'>
        {icon && (
          <span
            className='absolute'
            onClick={() =>
              type === 'password' && setShowPassword(!showPassword)
            }
          >
            {type === 'email' && (
              <EmailIcon
                className={`${
                  error
                    ? // && !focus
                      '!text-red-400 cursor-pointer'
                    : '!text-gray-400 cursor-pointer'
                }`}
              />
            )}
            {type === 'password' && !showPassword && (
              <PasswordIcon
                className={`${
                  error
                    ? //  && !focus
                      '!text-red-400 focus:!text-gray-400 cursor-pointer'
                    : '!text-gray-400 cursor-pointer'
                }`}
              />
            )}
            {type === 'password' && showPassword && (
              <HideIcon
                className={`${
                  error
                    ? // && !focus
                      '!text-red-400 focus:!text-gray-400 cursor-pointer'
                    : '!text-gray-400 cursor-pointer'
                }`}
              />
            )}
            {name === 'userName' && (
              <PersonIcon
                className={`${
                  error
                    ? // && !focus
                      '!text-red-400 focus:!text-gray-400 cursor-pointer'
                    : '!text-gray-400 cursor-pointer'
                }`}
              />
            )}
          </span>
        )}

        <input
          className={`block w-full py-3 my-1 
          ${icon ? 'pl-10 pr-3' : 'px-3'}
          ${disabled && 'cursor-not-allowed bg-slate-100 text-slate-500'}
          text-gray-700 bg-white border rounded-lg  focus:border-primary/40  focus:ring-primary/30 focus:outline-none focus:ring-1 focus:ring-opacity-60 
          ${
            error &&
            'border-red-400 placeholder:text-red-400 focus:border-red-400  focus:ring-red-400 focus:outline-none focus:ring-0 focus:ring-opacity-60'
          }
        placeholder:text-gray-400 focus:placeholder:text-gray-400`}
          type={
            type === 'password' && showPassword ? 'text' : type ? type : 'text'
          }
          placeholder={placeholder}
          autoComplete='off'
          name={name}
          disabled={disabled}
          value={value}
          onChange={onChange}
          checked={checked}
          // onFocus={handleFocus}
          // onBlur={handleBlur}
        />
      </div>
      {
        // !focus &&
        error && (
          <p className='text-red-400 text-xs ml-1 absolute -bottom-[13px]'>
            {errorMsg}
          </p>
        )
      }
    </div>
  );
};

export default TextField;
